import './pages.css';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { actionTypes } from './../../store';
import InputMask from 'react-input-mask';
import axios from "axios";
import { validationCpf, validationEmail } from "../../validations.js";
import { differenceInYears, parseISO } from 'date-fns';
import parse from 'html-react-parser';


export default function MicroArray({changePage}){
    const data = useSelector((state) => state.data?.microArray);
    const dispatch = useDispatch();
    const states = useSelector((state) => state.states);
    const [showFullText, setShowFullText] = useState(false);
    const baseData = {
          "nome_completo": "",
          "data_de_nascimento": "",
          "medico_solicitante": "",
          "nome_do_responsavel": "",
          "grau_de_parentesco": "",
          "gerais_atraso_de_desenvolvimento_global": "",
          "gerais_atraso_de_desenvolvimento_motor": "",
          "gerais_atraso_de_crescimento": "",
          "gerais_baixa_estatura": "",
          "gerais_restricao_do_crescimento_intrauterino": "",
          "gerais_crescimento_estrutural_exacerbado": "",
          "gerais_outro": "",
          "gerais_outro_desc": "",
          "neurologicas_agenesia_do_corpo_caloso": "",
          "neurologicas_ataxia": "",
          "neurologicas_malformacao_de_chiari": "",
          "neurologicas_hipotonia": "",
          "neurologicas_lisencefalia": "",
          "neurologicas_convulsoes": "",
          "neurologicas_surdez": "",
          "neurologicas_hidrocefalia": "",
          "neurologicas_hipertonia": "",
          "neurologicas_outro": "",
          "neurologicas_outro_desc": "",
          "neurologicas_option_deficit_de_aprendizagem": "",
          "neurologicas_option_deficit_de_aprendizagem_brando": "",
          "neurologicas_option_deficit_de_aprendizagem_moderado": "",
          "neurologicas_option_deficit_de_aprendizagem_severo": "",
          "neurologicas_option_espectro_do_autismo": "",
          "neurologicas_option_espectro_do_autismo_brando": "",
          "neurologicas_option_espectro_do_autismo_moderado": "",
          "neurologicas_option_espectro_do_autismo_severo": "",
          "neurologicas_option_problemas_comportamentais": "",
          "neurologicas_option_problemas_comportamentais_brando": "",
          "neurologicas_option_problemas_comportamentais_moderado": "",
          "neurologicas_option_problemas_comportamentais_severo": "",
          "neurologicas_option_deficit_intelectual": "",
          "neurologicas_option_deficit_intelectual_brando": "",
          "neurologicas_option_deficit_intelectual_moderado": "",
          "neurologicas_option_deficit_intelectual_severo": "",
          "abdominal_renal_defeito_anomalia_da_parede_abdominal": "",
          "abdominal_renal_hernia_inguinal_ou_umbilizal": "",
          "abdominal_renal_malformacao_renal": "",
          "abdominal_renal_outro": "",
          "abdominal_renal_outro_desc": "",
          "endocrina_metabolica_hipocalcemia": "",
          "endocrina_metabolica_hipercalcemia": "",
          "endocrina_metabolica_hipogonadismo": "",
          "endocrina_metabolica_hipotiroidismo": "",
          "endocrina_metabolica_outro": "",
          "endocrina_metabolica_outro_desc": "",
          "cardiacas_estenose_aortica": "",
          "cardiacas_defeito_do_septo_atrial": "",
          "cardiacas_atresia_pulmonar": "",
          "cardiacas_estenose_de_valvula_pulmonar": "",
          "cardiacas_tetralogia_de_fallot": "",
          "cardiacas_coarctacao_da_aorta": "",
          "cardiacas_defeito_do_septo_ventricular": "",
          "cardiacas_atresia_da_valvula_mitral": "",
          "cardiacas_estenose_da_arteria_pulmonar": "",
          "cardiacas_transposicao_das_grandes_arterias": "",
          "cardiacas_truncus_arteriosus": "",
          "cardiacas_outro": "",
          "cardiacas_outro_desc": "",
          "craniofacial_aniridia": "",
          "craniofacial_fenda_labial_palatina": "",
          "craniofacial_craniossinostose": "",
          "craniofacial_occipital_plano_ou_proeminente": "",
          "craniofacial_macrocefalia": "",
          "craniofacial_catarata": "",
          "craniofacial_coloboma_ocular": "",
          "craniofacial_deformidades_da_orelha": "",
          "craniofacial_frontal_proeminente": "",
          "craniofacial_microcefalia": "",
          "craniofacial_fistula_sinus_pre_auricular": "",
          "craniofacial_outro": "",
          "craniofacial_outro_desc": "",
          "genitais_malformacoes_do_anus_reto": "",
          "genitais_genitalia_ambigua": "",
          "genitais_criptorquidia": "",
          "genitais_hipogonadismo": "",
          "genitais_outro": "",
          "genitais_outro_desc": "",
          "esqueleticas_articulares_clinodactilia": "",
          "esqueleticas_articulares_pe_boto_torto": "",
          "esqueleticas_articulares_limitacao_articular": "",
          "esqueleticas_articulares_anomalias_das_costelas": "",
          "esqueleticas_articulares_escoliose": "",
          "esqueleticas_articulares_anomalias_do_polegar_ou_radio": "",
          "esqueleticas_articulares_outro": "",
          "esqueleticas_articulares_outro_desc": "",
          "historico_familiar_anomalias_congenitas": "",
          "historico_familiar_retardo_mental": "",
          "historico_familiar_abortos_recorrentes": "",
          "historico_familiar_outro": "",
          "historico_familiar_outro_desc": "",
          "historico_familiar_consanguinidade_parental": "",
          "historico_familiar_consanguinidade_parental_desc": "",
          "materna_caucasiana": "",
          "materna_afroamericana": "",
          "materna_indigena": "",
          "materna_asiatica": "",
          "materna_judia": "",
          "materna_outro": "",
          "materna_outro_desc": "",
          "paterna_caucasiana": "",
          "paterna_afroamericana": "",
          "paterna_indigena": "",
          "paterna_asiatica": "",
          "paterna_judia": "",
          "paterna_outro": "",
          "paterna_outro_desc": "",
          "paciente_ja_realizou_nao": "",
          "paciente_ja_realizou_sim": "",
          "paciente_ja_realizou_sim_desc": ""
        }
    const [currentData, setCurrentData] = useState({...baseData, "cancer_history":false,
        "cancer_family_items":[{id:"1",'Parentesco': "","Materno":false,"Paterno":false, "Local do cancer":"",
            "Idade do diagnóstico":""}],...data})


    const [items, setItems] = useState([
        {id:"general_information",title: "Informações Gerais do Paciente(obrigatório)", type:"b"},
        {id:'nome_completo', text: 'Nome completo', type:'input', class:'col-xs-12 col-lg-12'},
        {id:'data_de_nascimento', text: 'Data de Nascimento', type:'input', props: {type: 'date'}, class:'col-xs-12 col-lg-4'},
        {id:'medico_solicitante', text: 'Médico Solicitante', type:'input', class:'col-xs-12 col-lg-6'},
        {id:'nome_do_responsavel', text: 'Nome do(a) Responsável (se necessário)', type:'input', class:'col-xs-12 col-lg-6'},
        {id:'grau_de_parentesco', text: 'Grau de Parentesco do(a) Respo. com o(a) Paciente', type:'input', class:'col-xs-12 col-lg-6'},
        {id:"clinical_information",title: "Informações Clínicas", type:"b"},
        {id:'gerais', text: 'Gerais', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'atraso_de_desenvolvimento_global', name: 'Atraso de desenvolvimento global' },
                        { id: 'atraso_de_desenvolvimento_motor', name: 'Atraso de desenvolvimento motor' },
                        { id: 'atraso_de_crescimento', name: 'Atraso de crescimento' },
                        { id: 'baixa_estatura', name: 'Baixa estatura' },
                        { id: 'restricao_do_crescimento_intrauterino', name: 'Restrição do crescimento intrauterino' },
                        { id: 'crescimento_estrutural_exacerbado', name: 'Crescimento estrutural exacerbado' },
                        { id: 'outro', name: 'Outro', input: true}]},
        {id:'hr1',text:'', type:'hr'},
        {id:'neurologicas', text: 'Neurológicas', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'agenesia_do_corpo_caloso', name: 'Agenesia do corpo caloso' },
                    { id: 'ataxia', name: 'Ataxia' },
                    { id: 'malformacao_de_chiari', name: 'Malformação de Chiari' },
                    { id: 'hipotonia', name: 'Hipotonia' },
                    { id: 'lisencefalia', name: 'Lisencefalia' },
                    { id: 'convulsoes', name: 'Convulsões' },
                    { id: 'surdez', name: 'Surdez' },
                    { id: 'hidrocefalia', name: 'Hidrocefalia' },
                    { id: 'hipertonia', name: 'Hipertonia' },
                    { id: 'outro', name: 'Outro', input:true }]},
        {id:'hr2',text:'', type:'hr'},

        {id:'neurologicas_option', text: '', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'deficit_de_aprendizagem', name: 'Déficit de aprendizagem:',radio:true },
                    { id: 'espectro_do_autismo', name: 'Espectro do autismo:',radio:true },
                    { id: 'problemas_comportamentais', name: 'Problemas comportamentais:',radio:true },
                    { id: 'deficit_intelectual', name: 'Déficit intelectual:',radio:true }]},
        {id:'hr3',text:'', type:'hr'},
        {id:'abdominal_renal', text: 'Abdominal/Renal', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'defeito_anomalia_da_parede_abdominal', name: 'Defeito/anomalia da parede abdominal' },
                    { id: 'hernia_inguinal_ou_umbilizal', name: 'Hérnia inguinal ou umbilizal' },
                    { id: 'malformacao_renal', name: 'Malformação renal' },
                    { id: 'outro', name: 'Outro',input:true }]},
        {id:'hr4',text:'', type:'hr'},
        {id:'endocrina_metabolica', text: 'Endócrina/Metabólica', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'hipocalcemia', name: 'Hipocalcemia' },
                    { id: 'hipercalcemia', name: 'Hipercalcemia' },
                    { id: 'hipogonadismo', name: 'Hipogonadismo' },
                    { id: 'hipotiroidismo', name: 'Hipotiroidismo' },
                    { id: 'outro', name: 'Outro',input:true }]},
        {id:'hr5',text:'', type:'hr'},
        {id:'cardiacas', text: 'Cardíacas', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'estenose_aortica', name: 'Estenose aórtica' },
                    { id: 'defeito_do_septo_atrial', name: 'Defeito do septo atrial' },
                    { id: 'atresia_pulmonar', name: 'Atresia pulmonar' },
                    { id: 'estenose_de_valvula_pulmonar', name: 'Estenose de válvula pulmonar' },
                    { id: 'tetralogia_de_fallot', name: 'Tetralogia de Fallot' },
                    { id: 'coarctacao_da_aorta', name: 'Coarctação da aorta' },
                    { id: 'defeito_do_septo_ventricular', name: 'Defeito do septo ventricular' },
                    { id: 'atresia_da_valvula_mitral', name: 'Atresia da válvula mitral' },
                    { id: 'estenose_da_arteria_pulmonar', name: 'Estenose da artéria pulmonar' },
                    { id: 'transposicao_das_grandes_arterias', name: 'Transposição das grandes artérias' },
                    { id: 'truncus_arteriosus', name: 'Truncus Arteriosus' },
                    { id: 'outro', name: 'Outro',input:true }]},
        {id:'hr6',text:'', type:'hr'},
        {id:'craniofacial', text: 'Craniofacial', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'aniridia', name: 'Aniridia' },
                    { id: 'fenda_labial_palatina', name: 'Fenda labial/palatina' },
                    { id: 'craniossinostose', name: 'Craniossinostose' },
                    { id: 'occipital_plano_ou_proeminente', name: 'Occipital plano ou proeminente' },
                    { id: 'macrocefalia', name: 'Macrocefalia' },
                    { id: 'catarata', name: 'Catarata' },
                    { id: 'coloboma_ocular', name: 'Coloboma ocular' },
                    { id: 'deformidades_da_orelha', name: 'Deformidades da orelha' },
                    { id: 'frontal_proeminente', name: 'Frontal proeminente' },
                    { id: 'microcefalia', name: 'Microcefalia' },
                    { id: 'fistula_sinus_pre_auricular', name: 'Fístula/Sinus pré-auricular' },
                    { id: 'outro', name: 'Outro',input:true }]},
        {id:'hr7',text:'', type:'hr'},
        {id:'genitais', text: 'Genitais', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'malformacoes_do_anus_reto', name: 'Malformações do ânus/reto' },
                    { id: 'genitalia_ambigua', name: 'Genitália ambígua' },
                    { id: 'criptorquidia', name: 'Criptorquidia' },
                    { id: 'hipogonadismo', name: 'Hipogonadismo' },
                    { id: 'outro', name: 'Outro',input:true }]},
        {id:'h8',text:'', type:'hr'},
        {id:'esqueleticas_articulares', text: 'Esqueléticas/Articulares', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'clinodactilia', name: 'Clinodactilia' },
                    { id: 'pe_boto_torto', name: 'Pé boto/torto' },
                    { id: 'limitacao_articular', name: 'Limitação articular' },
                    { id: 'anomalias_das_costelas', name: 'Anomalias das costelas' },
                    { id: 'escoliose', name: 'Escoliose' },
                    { id: 'anomalias_do_polegar_ou_radio', name: 'Anomalias do polegar ou rádio' },
                    { id: 'outro', name: 'Outro',input:true }]},
        {id:'hr9',text:'', type:'hr'},
        {id:'historico_familiar', text: 'Histórico Familiar', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'anomalias_congenitas', name: 'Anomalias congênitas' },
                    { id: 'retardo_mental', name: 'Retardo mental' },
                    { id: 'abortos_recorrentes', name: 'Abortos recorrentes' },
                    { id: 'consanguinidade_parental', name: 'Consanguinidade parental? Se sim, grau da relação',input:true },
                    { id: 'outro', name: 'Outro',input:true }]},
        {id:'hr10',text:'', type:'hr'},
        {id:"etnia_parental",text: "Etnia Parental", type:"label"},
        {id:'materna', text: 'Materna', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'caucasiana', name: 'Caucasiana' },
                    { id: 'afroamericana', name: 'Afroamericana' },
                    { id: 'indigena', name: 'Indígena' },
                    { id: 'asiatica', name: 'Asiática' },
                    { id: 'judia', name: 'Judia' },
                    { id: 'outro', name: 'Outro',input:true }]},
        {id:'paterna', text: 'Paterna', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'caucasiana', name: 'Caucasiana' },
                    { id: 'afroamericana', name: 'Afroamericana' },
                    { id: 'indigena', name: 'Indígena' },
                    { id: 'asiatica', name: 'Asiática' },
                    { id: 'judia', name: 'Judia' },
                    { id: 'outro', name: 'Outro',input:true }]},
        {id:'hr11',text:'', type:'hr'},
        {id:'paciente_ja_realizou', text: 'Paciente já realizou outro estudo cromossômico (Cariótipo ou outro)?', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'nao', name: 'Não' },
                    { id: 'sim', name: 'Sim. Qual o resultado?',input:true }]},
        {id:'hr12',text:'', type:'hr'},

    ]);

    const radioOptions = [{id:"brando",title: "Brando"}, {id:"moderado",title: "Moderado"}, {id:"severo",title: "Severo"}]
    const handleSubmit = (event) => {
        event.preventDefault();
        var eventName = event.nativeEvent.submitter.name;
        if (eventName === "finish"){
            var hasError = false;
            var fields = ['nome_completo','data_de_nascimento','medico_solicitante','paciente_ja_realizou']
            fields.forEach((f) => {
                if(!(f in currentData) || currentData[f] == "" || currentData[f] == null){
                    setError(f,'Campo Obrigatório')
                    hasError = true;
                }
                else{
                    setError(f, null);
                }
            })
            if(!hasError){
                changePage(eventName)
            }
        }
        else{
                changePage(eventName)
        }
    }
    const setValue = (id, value,listCheck = false) => {
        setError(id, null);

        setCurrentData((actualData) => {
            if(listCheck === true){
                if(id in actualData){
                    const index = actualData[id].indexOf(value);
                    value = index === -1? [...actualData[id], value]: actualData[id].filter(item => item !== value);
                }
                else{
                    value = [value]
                }
            }
            return ({...actualData, [id]:value});
        })

    }
    //Marca o status de erro e a mensagem de um campo
    function setError(id,value,key="error"){
          setItems((currentItens) => currentItens.map((i) => {
            if(i.id === id ){
                return {...i, [key]: value}
            }
            return i
          }))
    }
    function addNewLine(){
        var newItem = {'Parentesco': "","Materno":false,"Paterno":false, "Local do cancer":"",
            "Idade do diagnóstico":""};

        setCurrentData((c) => ({...c,cancer_family_items:[...c.cancer_family_items,{...newItem,id:c.cancer_family_items.length} ]}))
    }
    useEffect(()=>{
        if(currentData){
            dispatch({ type: actionTypes.set_data, 'payload': {"microArray":currentData}});
        }
    },[currentData])
    const getItem = (i, d) => {
        switch (i.type) {
            case "b":
                return (
                 <b id={i.id} className="subtitle">{i.title}</b>
                )
            case "input":
                return (
                    <InputMask key={i.id} id={i.id} name={i.id} type="text" placeholder={i.placeholder} title=""
                        value={d && d[i.id]} autoComplete="off" {...i.props} disabled={i.disabled === true}
                        onChange={(event) => setValue(i.id, event.target.value)}  mask={i.mask}
                        className={i.error ? 'border-danger' : ''} />
                );
            case "checkbox":
                return (
                    <label key={i.id} className="label-input label-radio d-flex">
                        <input id={i.id} className="checkInput" type="checkbox" name={i.id}
                            checked={d && d[i.id] } onChange={(event) => setValue(i.id, event.target.checked)} />
                        <b>{parse(i.name)}</b>
                        {(i.input === true && d[i.id] === true) &&
                            <InputMask key={`input_${i.id}`} id={`input_${i.id}`} name={`input_${i.id}`}
                                type="text" value={d && d[`${i.tag}age_${i.id}`]} autoComplete="off"
                                placeholder={i.placeholder}
                                onChange={(event) => setValue(`age_${i.id}`, event.target.value)}
                                className={i.error ? 'border-danger' : ''} />
                        }

                    </label>
                );
            case "select":
                return (
                    <select key={i.id} id={i.id} name={i.id} onChange={(event) => setValue(i.id, event.target.value)}>
                        {i.options?.map((o) => (
                            <option key={o.id} value={o.id}>
                                {parse(o.name)}
                            </option>
                        ))}
                    </select>
                );
            case "radio":
                return (
                    <div key={i.id} id={i.id} className="d-flex div-radio">
                        {i.options?.map((o) => (
                            <label key={o.id} className="label-input label-radio d-flex">
                                <input id={o.id} className="radioInput" type="radio" name={i.id}
                                    checked={d && d[i.id] === o.id}
                                    onChange={(event) => setValue(i.id, event.target.id)} />
                                <b>{parse(o.name)}</b>
                                {(o.input === true && d[i.id] === o.id) &&
                                    <InputMask key={`input_${o.id}`} id={`input_${o.id}`} name={`input_${o.id}`}
                                        type="text" value={d && d[o.id]} autoComplete="off"
                                        placeholder={o.placeholder}
                                        onChange={(event) => setValue(o.id, event.target.value)}
                                        className={i.error ? 'border-danger' : ''} />
                                }
                            </label>
                        ))}
                    </div>
                );
            case "listCheck":
                return (
                    <div key={i.id} id={i.id} className="d-flex div-radio">
                        {i.options?.map((o) => (
                            <div className="div-input d-flex">
                                <label key={o.id} className="label-input label-radio d-flex">
                                    <input id={o.id} className="radioInput" type="checkbox" name={i.id}
                                        checked={d && d[i.id]?.includes(o.id)}
                                        onChange={(event) => setValue(i.id, event.target.id,true)} />
                                    <b>{parse(o.name)}</b>
                                </label>
                                {(o.input === true && d[i.id]?.includes(o.id)) &&
                                    <InputMask key={`input_${o.id}`} id={`input_${o.id}`} name={`input_${o.id}`}
                                        type="text" value={d && d[`${i.id}_${o.id}_desc`]} autoComplete="off"
                                        placeholder={o.placeholder}
                                        onChange={(event) => setValue(`${i.id}_${o.id}_desc`, event.target.value)}
                                        className={i.error ? 'border-danger' : ''} />
                                }
                                {(o.radio === true && d[i.id]?.includes(o.id)) &&
                                    radioOptions.map((r) =>
                                        <>
                                            <input id={`${o.id}_${r.id}`} key={`${o.id}_${r.id}`} name={`${o.id}_option`}
                                                type="radio" className="radioInput" checked={d && d[`${i.id}_${o.id}_check`] == `${o.id}_${r.id}`}
                                                onChange={(event) => setValue(`${i.id}_${o.id}_check`, event.target.id)} />
                                            <b>{parse(r.title)}</b>
                                        </>
                                    )
                                }
                            </div>
                        ))}
                    </div>
                );
            case "hr":
                return (<hr key={i.id} />);
            default:
                return (<div key={i.id} className={`div-input ${i.class}`}></div>);
        }
    };

     return(
        <div className="basePage">
            <h4 className="title">Formulário para Requisição de Amostra</h4>
            <p className="subtitle">para Análise Cromossômica por MicroArray</p>
            <form key="form2" id="form2" onSubmit={handleSubmit}>
                <div className="row g-0">
                    { items.map((i)=>{
                        if(!("show" in i) || i.show.every((s) => currentData[s.key] === s.value)) {
                            return(
                                <div key={i.id} className={`div-input ${i.class}`}>
                                    {i.text != '' && <label htmlFor={i.id} className="label-input">{i.text}</label>}
                                    <div className="input-page-1" style={{"width": "100%"}}>
                                        {getItem(i,currentData)}
                                        {i.error && <span className="error-text">{i.error}</span>}
                                    </div>
                                </div>)
                        }
                    })}
                </div>

            </form>
            <br/>
        </div>
    );
}